import { IPagingOptions } from '@/coreDomainsModule/paging';
import { ISupplierForecastResult } from '../domains/entities/supplierForecastData';
import { GetSupplierForecastResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/supplierForecastManage';
import { IBusinessForSupplierForecast } from '@/coreDomainsModule/entities/businessForSupplierForecast';
import { SupplierForecastAdapter } from './supplierForecastAdapter';
import { TableContentItem } from '@/corePagesModule/BaseTableContent/interface/tableContentItems';
import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 * 仕入先内示ページの全取引を取得APIのアダプター
 */
export class AllBusinessesForSupplierForecastAdapter {
  /**
   * responseをUI用にresultに変換する
   * @param response - APIのresponse
   */
  public static adapt = (response: GetSupplierForecastResponseAllOfResult): ISupplierForecastResult => {
    const data: Partial<IBusinessForSupplierForecast>[] = response.data.map((businessAndForecast) => {
      return {
        businessId: businessAndForecast.aggregateBusinessId,
        aggregateBusinessResponsibleUsers:
          businessAndForecast.aggregateBusinessResponsibleUsers?.map((user) =>
            UserAccountFactory.create({ email: user?.id, name: user?.name })
          ) ?? [],
        supplierNumber: businessAndForecast.supplierNumber,
        supplierName: businessAndForecast.supplierName,
        businessNumber: businessAndForecast.businessNumber,
        businessName: businessAndForecast.businessName,
        package: businessAndForecast.package.addComma(),
        unit: businessAndForecast.unit,
        manufacturer: businessAndForecast.manufacturer,
        warehouseNumber: businessAndForecast.warehouseNumber,
        warehouse: businessAndForecast.warehouse,
        purchaseUnitPrice: businessAndForecast.purchaseUnitPrice != null ? Number(businessAndForecast.purchaseUnitPrice) : undefined,
        supplierForecasts: businessAndForecast.supplierForecasts?.map((forecast) => SupplierForecastAdapter.adapt(forecast)) ?? [],
      };
    });
    const result: TableContentItem[] = data.map((business) => {
      return {
        displayId: business.businessId ?? '',
        isVirtualChild: false,
        ...business,
        ...BusinessFactory.create(business),
      };
    });
    return {
      result,
      pagingOptions: { ...response.pagingOptions },
    };
  };
}
